// extracted by mini-css-extract-plugin
export default {"delete-confirmation-dialog":"CertificateListView_delete-confirmation-dialog__hkIG3","note":"CertificateListView_note__ffsoX"};